import NoPlayers from "./NoPlayers";
import SettingsLayout from "./SettingsLayout";
import {SettingsFormProps} from "./types";

export interface SettingsContainerProps extends SettingsFormProps {
    embedMethod: "embed" | "oembed";
    allowOembedConfig?: boolean;
    isTimingAllowed: boolean;
}

const SettingsContainer = (props: SettingsContainerProps) => {

    const {embedSettings, onClose} = props;
    const v7Players = embedSettings.filter(player => player.isPlayerV7);

    return (
        <>
            {v7Players.length > 0 && <SettingsLayout {...props} />}

            {v7Players.length === 0 && <NoPlayers onClose={onClose} />}
        </>

    )
}

export default SettingsContainer;
